export const visit = (vm, at) => {
at({ "es": { "conversations-visitor-ui": { "pageTitleNotifications": { "newMessage": "Mensaje nuevo" } } } });
};